import { lazy } from 'react';

const PayrollRunsListPage = lazy(() => import('../pages/PayrollRunsList.page'));
const PayrollRunDetailPage = lazy(() => import('../pages/PayrollRunDetail.page'));
const EmployeePayslipPage = lazy(() => import('../pages/EmployeePayslip.page'));

export const PayrollRoutes = [
    {
        path: '/finances/payroll',
        element: <PayrollRunsListPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/finances/payroll/payslip/:employeePayrollId',
        element: <EmployeePayslipPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/finances/payroll/:runId',
        element: <PayrollRunDetailPage />,
        layout: 'default',
        isAuthReq: true,
    },
];
